import { Shop } from '../types';

/**
 * Convert a shop name to a URL-friendly slug
 * @param shop Shop object or shop name
 * @returns URL-friendly slug
 */
export const getShopSlug = (shop: Shop | string): string => {
  const shopName = typeof shop === 'string' ? shop : shop.name;
  return shopName.toLowerCase().replace(/\s+/g, '-');
};

/**
 * Generate a shop-specific URL
 * @param shop Shop object or shop name
 * @param path Path to append after the shop (default: empty)
 * @returns Full shop URL
 */
export const getShopUrl = (shop: Shop | string, path: string = ''): string => {
  const slug = getShopSlug(shop);
  const basePath = `/shop/${slug}`;
  return path ? `${basePath}/${path.replace(/^\//, '')}` : basePath;
};

/**
 * Generate a login URL for a specific shop
 * @param shop Shop object or shop name
 * @returns Shop-specific login URL
 */
export const getShopLoginUrl = (shop: Shop | string): string => {
  return getShopUrl(shop, 'login');
};

/**
 * Generate a booking URL for a specific shop
 * @param shop Shop object or shop name
 * @returns Shop-specific booking URL
 */
export const getShopBookingUrl = (shop: Shop | string): string => {
  return getShopUrl(shop, 'book-appointment');
}; 